import React from "react";
import { Button, Result } from "antd";
import { getUser } from "services/auth";
import { useHistory } from "react-router";
import { ResultStatusType } from "antd/lib/result";

function NotFoundPage(props: {
  status?: ResultStatusType;
  title?: string;
  subTitle?: string;
}) {
  const {
    status = "404",
    title = "404",
    subTitle = "Sorry, the page you visited does not exist."
  } = props;
  const history = useHistory();
  const userInfo = getUser();

  return (
    <Result
      status={status}
      title={title}
      subTitle={subTitle}
      extra={
        <Button
          type="primary"
          data-testid="index-button-back-home"
          onClick={() => {
            if (userInfo) {
              history.push("/projects");
            } else {
              history.push("/");
            }
          }}
        >
          Back Home
        </Button>
      }
    />
  );
}
export default NotFoundPage;
